import {Component, Inject, OnInit, ViewChild, ElementRef, EventEmitter} from '@angular/core';
import {ConfService} from '../conf.service';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatIconRegistry, MatSnackBar} from '@angular/material';
import {ActivatedRoute, Router} from '@angular/router';
import {DomSanitizer} from '@angular/platform-browser';
import {KongService} from '../kong.service';
import {EntityVersions} from '../crudapi/crudapi.component';
import {environment} from '../../environments/environment.prod';
import {FormControl, NgModel} from '@angular/forms';
import {NgForm} from '@angular/forms';
import {LeftpanelComponent, LoaderWithProgressComponent} from '../leftpanel/leftpanel.component';
import * as CryptoJS from 'crypto-js';
import {DatabasesListenerService} from '../databases-listener.service';

declare let $;

class ImageSnippet {
    constructor(public src: string, public file: File) {
    }
}

export interface DialogData {
    account_id: string;
    account_desc: string;
    account_email: string;
    account_password: string;
    account_roles: any;
}

export interface DatabaseData {
    database_name: string;
    database_type: string;
    username: string;
    password: string;
    host: string;
    port: string;
    dbName: string;
    connectionString: string;
}

export interface NameValuePair {
    name: string;
}

@Component({
    selector: 'app-partner-onboard',
    templateUrl: './partner-onboard.component.html',
    styleUrls: ['./partner-onboard.component.css']
})
export class PartnerOnboardComponent implements OnInit {

    @ViewChild('logoMarkInput') logoMarkInput: ElementRef;
    loadingStatus: EventEmitter<any> = new EventEmitter();

    /*partner: string;
    partnerOrganization: string;
    partnerOrganizationType: string;
    primaryEmail: string;
    primaryPhone: string;
    accountpassword: string;
    secondaryemail: string;
    secondaryphone: string;
    addressLine1: string;
    addressLine2: string;
    city: string;
    state: string;
    country: string;
    pincode: number;
    localization: string;*/
    captchaSiteKey: string;
    captach: string;
    couponCode: string;
    hide = true;
    columns: any;
    dbColumns: any;
    item: any;
    dataBaseData: any;
    currentPlanDisplayName: string;
    partnerDatabases: any;
    name: string;
    getIPWhitelist: any;
    accountHeader = ['account', 'account_email', 'account_desc'];
    createAccount = {account_id: '', account_desc: '', account_email: '', account_password: ''};
    // listOfDatabases = ['mongodb', 'dynamodb', 'mysql', 'postgresql', 'sqlserver', 'cosmosdb', 'aurora-mysql', 'aurora-postgresql', 'snowflake'];
    // listOfDatabases = ['mongodb', 'dynamodb', 'oracle', 'mysql', 'sqlserver'];
    defaultDB = 'mongodb';
    database: string;
    apiKeys: any;
    apiKeyData: any;
    apiKey: any;
    adfsData: any;
    adfsConfigs: any;
    identityProviders: NameValuePair[] = [
        {name: 'Active Directory'}
        // ,
        // {name: 'OKTA'},
        // {name: 'Microsoft Azure'},
        // {name: 'Google Suite'}
        // {name: 'VMWare Workspace One'}
    ];
    identityProvider = 'Active Directory';
    identityProviderName: string;
    identityProviderTypes: NameValuePair[] = [
        {name: 'SAML'}
    ];
    identityProviderType = 'SAML';
    metadataFilePath: string;

    appClientDetailsForPartner: any;
    registeredIdProviders: any;
    supportedIdps: any;
    appClientID: any;

    businessDetails = false;
    Accounts = false;
    APIKeys = false;
    BusinessLocations = false;
    Databases = false;
    IPWhitelist = false;
    IdentityProvider = false;
    logo = false;
    credits = false;
    myControl = new FormControl();
    logoMarkPayload = {
        'logoType': 'logoMark',
        'imageHeight': 50,
        'imageWidth': 50,
    };
    brandImagePayload = {
        'logoType': 'brandImage',
        'imageHeight': 60,
        'imageWidth': 180,
    };
    partner = localStorage.getItem('partner');
    account = localStorage.getItem('account');
    removeDBConnectionsStatus = [];
    DBConnectionsUpdateStatus = [];

    constructor(private confPost: ConfService, private kong: KongService, public platform: LeftpanelComponent, private router: Router,
                private Urlroute: ActivatedRoute, public dialog: MatDialog, public databasesListenerInstance: DatabasesListenerService,
                iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
        iconRegistry.addSvgIcon(
            'video',


            sanitizer.bypassSecurityTrustResourceUrl('/assets/img/video.svg'));
    }


    openDialog(): void {
        const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
            width: '500px',
            data: this.createAccount
        });

        dialogRef.afterClosed().subscribe(result => {
        });
    }

    openDatabaseDialog(): void {
        const dialogRef = this.dialog.open(CreateDatabaseComponent, {
            width: '650px',
            data: this.dbColumns
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                window.location.reload();
            }
        });
    }

    openDatabaseDialogForUpdate(data): void {
        const dialogRef = this.dialog.open(CreateDatabaseComponent, {
            width: '650px',
            data: data
        });

        dialogRef.afterClosed().subscribe(result => {
        });
    }


    getAppClientIdForPartner() {
        const describeClientData = {
            'customerName': localStorage.getItem('partner')
        };
        this.confPost.getAppClientDetailsForPartner(describeClientData).subscribe(data => {
            this.appClientDetailsForPartner = data;
            return this.appClientDetailsForPartner.customerId;
        }, error => {
            this.platform.handleErrorGracefully(error, 'Error in fetching App Client ID');
        });
    }

    resolved(captchaResponse: string) {
        this.captach = captchaResponse;
    }

    sendPromoCode() {
        if (this.couponCode !== undefined && this.couponCode !== '') {
            if (this.captach !== null && this.captach !== undefined) {
                this.captach = null;
            } else {
                this.platform.openSnackBar('Perform captcha action to proceed', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }
        } else {
            this.platform.openSnackBar('Please provide a coupon code to proceed', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }

    businessDetailsshow() {
        this.businessDetails = true;
        this.Accounts = false;
        this.APIKeys = false;
        this.BusinessLocations = false;
        this.Databases = false;
        this.IPWhitelist = false;
        this.IdentityProvider = false;
        this.logo = false;
        this.credits = false;
    }

    Accountsshow() {
        this.businessDetails = false;
        this.Accounts = true;
        this.APIKeys = false;
        this.BusinessLocations = false;
        this.Databases = false;
        this.IPWhitelist = false;
        this.IdentityProvider = false;
        this.logo = false;
        this.credits = false;
    }

    APIKeysshow() {
        this.businessDetails = false;
        this.Accounts = false;
        this.APIKeys = true;
        this.BusinessLocations = false;
        this.Databases = false;
        this.IPWhitelist = false;
        this.IdentityProvider = false;
        this.logo = false;
        this.credits = false;

    }

    BusinessLocationsshow() {
        this.businessDetails = false;
        this.Accounts = false;
        this.APIKeys = false;
        this.BusinessLocations = true;
        this.Databases = false;
        this.IPWhitelist = false;
        this.IdentityProvider = false;
        this.logo = false;
        this.credits = false;

    }

    Databasesshow() {
        this.businessDetails = false;
        this.Accounts = false;
        this.APIKeys = false;
        this.BusinessLocations = false;
        this.Databases = true;
        this.IPWhitelist = false;
        this.IdentityProvider = false;
        this.logo = false;
        this.credits = false;
    }

    IPWhitelistshow() {
        this.businessDetails = false;
        this.Accounts = false;
        this.APIKeys = false;
        this.BusinessLocations = false;
        this.Databases = false;
        this.IPWhitelist = true;
        this.IdentityProvider = false;
        this.logo = false;
        this.credits = false;
    }

    IdentityProvidershow() {
        this.businessDetails = false;
        this.Accounts = false;
        this.APIKeys = false;
        this.BusinessLocations = false;
        this.Databases = false;
        this.IPWhitelist = false;
        this.IdentityProvider = true;
        this.logo = false;
        this.credits = false;
    }

    showLogo() {
        this.businessDetails = false;
        this.Accounts = false;
        this.APIKeys = false;
        this.BusinessLocations = false;
        this.Databases = false;
        this.IPWhitelist = false;
        this.IdentityProvider = false;
        this.logo = true;
        this.credits = false;
    }

    creditsShow() {
        this.businessDetails = false;
        this.Accounts = false;
        this.APIKeys = false;
        this.BusinessLocations = false;
        this.Databases = false;
        this.IPWhitelist = false;
        this.IdentityProvider = false;
        this.logo = false;
        this.credits = true;
    }


    registerAdfsConfiguration(fileInput: any) {
        if (this.metadataFilePath) {
            this.confPost.registerIdentityProviderWithUrl(this.identityProviderName, this.identityProviderType, this.metadataFilePath).subscribe(data => {
                const describeClientData = {
                    'customerName': localStorage.getItem('partner')
                };
                this.confPost.getAppClientDetailsForPartner(describeClientData).subscribe(data => {
                    this.appClientDetailsForPartner = data;
                    this.appClientID = this.appClientDetailsForPartner.customerId;
                    if (this.appClientID) {
                        this.supportedIdps = this.appClientDetailsForPartner.supportedIdps;
                        this.supportedIdps.push(this.identityProviderName);
                        const updateClientData = {
                            'clientName': localStorage.getItem('partner'),
                            'customerId': this.appClientID,
                            'supportedIps': this.supportedIdps
                        };
                        this.confPost.updateAppClientSettings(updateClientData).subscribe(updateRes => {
                            this.platform.openSnackBar('ADFS Configuration has been registered successfully', 'Success', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        }, error => {
                            this.platform.handleErrorGracefully(error, 'Error in registering ADFS configuration');
                        });
                    }
                }, error => {
                    this.platform.handleErrorGracefully(error, 'Error while fetching client settings');
                });
            }, error => {
                this.platform.handleErrorGracefully(error, 'Error while updating client settings');
            });
        } else {
            // if (fileInput) {
            //     const file: File = fileInput.files[0];
            //     const reader = new FileReader();
            // }

        }
        // this.adfsData = {
        //     'providerName' : this.identityProviderName,
        //     // 'provider' : this.identityProvider,
        //     'providerType' : this.identityProviderType,
        //     'metadataUrl' : this.metadataFilePath,
        //     'metadataFilePath' : this.metadataFilePath
        // };
        // this.confPost.registerIdentityProvider(this.adfsData).subscribe(data => {
        //     this.registeredIdProviders = data;
        //
        //
        // });
        //
        //
        // this.confPost.updateAdfsConfiguration(this.adfsData, localStorage.getItem('partner')).subscribe(data => {
        //     this.platform.openSnackBar('ADFS Configuration updated successfully', 'Success', {
        //         duration: 5000,
        //         verticalPosition: 'top',
        //         horizontalPosition: 'center'
        //     });
        // }, error => {
        //     this.platform.openSnackBar(error.error.message, 'Error', {
        //         duration: 5000,
        //         verticalPosition: 'top',
        //         horizontalPosition: 'center'
        //     });
        // });
    }

    ngOnInit() {
        this.setcolumnvalues();
        $('ul li ').click(function () {
            $(this).addClass('selected').siblings().removeClass('selected');
        });

        // this.confPost.getCaptchaSiteKey().subscribe(response => {
        //     this.captchaSiteKey = response[0]['value'];
        // });

    }

    setcolumnvalues(): any {

        // this.getApiKeyForUser(this.item.primary_email);
        this.apiKey = localStorage.getItem('apikey');
        this.confPost.getPartner(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
            this.item = data;
            // this.apiKey = localStorage.getItem('apikey');
            // this.kong.getKeyAuthForConsumerInApiGatewayByNameOrId(this.item.primary_email).subscribe(keys => {
            //     this.apiKeyData = keys;
            //     this.apiKeys = this.apiKeyData.data;
            //     this.apiKey = this.apiKeys[0].key;
            // });
        });

        // this.confPost.getData('services', 'services', 'v1', 'settings', 'partner=' + localStorage.getItem('partner') + '&account=' + localStorage.getItem('account')).subscribe(data => {
        //     this.partnerDatabases = data[0]['configurations']['databases'];
        //     this.getSelectedDB(this.defaultDB);
        // }, error => {
        //     this.platform.openSnackBar(error.error.message, 'Error', {
        //         duration: 5000,
        //         verticalPosition: 'top',
        //         horizontalPosition: 'center'
        //     });
        // });


        this.confPost.getDatabases(localStorage.getItem('partner')).subscribe(async data => {
            await this.platform.updateIsNoSQLForMongo(data);
            this.partnerDatabases = this.platform.databases;
            /*this.partnerDatabases = [{
                'database_name': 'default',
                'database_type': 'mongodb',
                'database_attributes': {
                    'username': '1',
                    'password': '2',
                    'host': '3',
                    'port': '4',
                    'dbName': '5',
                    'connectionString': ''
                }
            }, {
                'database_name': 'MyDB',
                'database_type': 'dynamodb',
                'database_attributes': {'access_key': '123', 'secret_key': '567', 'region': 'us-west-2'}
            }];*/
            this.getSelectedDB(this.defaultDB);
        }, error => {

            this.platform.handleErrorGracefully(error, 'Error while retrieving databases');
        });

        this.confPost.getAdfsConfigs(localStorage.getItem('partner')).subscribe(data => {
            if (data) {
                this.adfsConfigs = data[0];
            }
        }, error => {
            this.platform.handleErrorGracefully(error, 'Error while getting retrieving configs');
        });

    }

    getSelectedDB(val) {
        this.getSelectedDBColumn(val);
        this.dataBaseData = [];
        this.partnerDatabases.filter(items => {
            if (items.database_type === val) {
                this.dataBaseData.push(items);
            }
        });
    }


    getSelectedDBColumn(val) {

        const dataColumn = [];
        if (this.platform.databasesMeta && this.platform.databasesMeta !== null && this.platform.databasesMeta !== undefined) {
            this.platform.databasesMeta.filter(items => {
                if (items.database_type === val) {
                    dataColumn.push(items);
                }
            });
            this.dbColumns = [];
            const db_type = {};
            db_type['database_type'] = this.defaultDB;
            this.dbColumns.push(db_type);
            for (const item of dataColumn) {
                for (const itemval of item.database_attributes) {
                    this.dbColumns.push({display_name: itemval['display_name'], name: itemval['name']});
                }
            }
        }
    }

    typeOfval(val) {
        return typeof val;
    }

    stringifyjson(val) {
        return JSON.stringify(val);
    }

    getCurrentPlanDisplayName(val) {
        if (val === 'tenrupeesapi') {
            return 'Enterprise';
        } else {

            return 'Community';
        }
    }

    sendIPWhitelist(text) {
        const ipWhitelist = [];
        if (text) {
            const textarray = text.replace(/\n/g, ',').split(',');
            textarray.forEach((data) => {
                ipWhitelist.push(data);
            });
        }
        this.confPost.updateIPWhitelist(localStorage.getItem('partner'), ipWhitelist).subscribe(data => {
            this.platform.openSnackBar('IP Whitelist added successfully', 'Success', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }, error => {
            this.platform.handleErrorGracefully(error, 'Error while adding whitelist');
        });
    }

    async testConnection(data1, index, event) {
        // const db = val[0]['database_name'];

        Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'databaseconnection_test_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response => {
            const payloadToSend = {
                actions: response
            };
            this.databasesListenerInstance.databasesListener.emit({
                type: 'audit',
                id: localStorage.getItem('IdOfSession'),
                payload: payloadToSend
            });
        });

        let val = JSON.parse(JSON.stringify(data1[index]));
        if (val['database_type'] === 'csv') {
            val['database_attributes'] = {
                'files': [
                    {
                        'url': val['database_attributes']['url'],
                        'name': val['database_attributes']['name']
                    }
                ],
                'connectionType': val['database_attributes']['connectionType']
            };
        }
        if (val.hasOwnProperty('audit_logs')) {
            delete val['audit_logs'];
        }
        if (val['database_name'] !== '') {
            const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
                maxWidth: '95vw',
                maxHeight: '60vh',
            });
            let result = {};
            await(this.platform.encryptDatabaseAttributes(val)).then(resp => {
                if (resp.hasOwnProperty('database')) {
                    val = resp['database'];
                    result = {
                        shash: resp['database']['shash'],
                        ralam: resp['database']['ralam'],
                    };
                }
            });
            if (val.hasOwnProperty('shash')) {
                delete val['shash'];
            }
            if (val.hasOwnProperty('ralam')) {
                delete val['ralam'];
            }
            result['databaseDetails'] = val;
            this.confPost.testConnectionDatabase(result).subscribe(data => {

                Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'databaseconnection_test_success', 'INFO', data.status, data.statusText, '', {databasePayload: val}, data, this.router.url)).then(resp => {
                    const payloadToSend = {
                        actions: resp
                    };
                    this.databasesListenerInstance.databasesListener.emit({
                        type: 'audit',
                        id: localStorage.getItem('IdOfSession'),
                        payload: payloadToSend
                    });
                });

                this.platform.openSnackBar('Connection Successful', 'Success', {
                    duration: 3000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                loaderDialog.close();
                $(event.target).css('color', 'green');

                // $('#databaseView').find('tbody tr').find('td').each(function () {
                //     $(this).find('.status-icon').css('color', 'green');
                //
                // });
            }, error => {
                loaderDialog.close();
                Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'databaseconnection_test_failed', 'ERROR', error.status, error.statusText, this.platform.returnErrorMessage(error), {databasePayload: val}, error, this.router.url)).then(resp => {
                    const payloadToSend = {
                        actions: resp
                    };
                    this.databasesListenerInstance.databasesListener.emit({
                        type: 'audit',
                        id: localStorage.getItem('IdOfSession'),
                        payload: payloadToSend
                    });
                });
                this.platform.handleErrorGracefully(error, 'Error occurred while testing the DB Connection. Please try again after sometime.');
                $(event.target).css('color', 'red');

            });
        } else {
            alert('Database name cannot be empty');
        }
    }

    patchAdminPartnerSettingsForUpdate(partnerName, accountId, data, envType, environments, isFromAdmin, shash, ralam) {
        return new Promise((resolve, reject) => {
            this.confPost.getSettingsV2CRUD(partnerName, accountId, false).subscribe(res => {
                if (res && res['body'] && res['body'][0]) {
                    const response1 = res['body'];
                    if (isFromAdmin === true) {
                        for (let i = 0; i < response1[0]['environments'].length; i++) {
                            for (let j = 0; j < response1[0]['environments'][i]['services'].length; j++) {
                                if (response1[0]['environments'][i]['services'][j]['type'] === 'databases') {
                                    for (let k = 0; k < response1[0]['environments'][i]['services'][j]['configurations'].length; k++) {
                                        if (response1[0]['environments'][i]['services'][j]['configurations'][k]['database_name'] === data['database_name']) {
                                            let audit_logs = [];
                                            audit_logs = response1[0]['environments'][i]['services'][j]['configurations'][k]['audit_logs'];
                                            const is_default = response1[0]['environments'][i]['services'][j]['configurations'][k]['is_default'];
                                            audit_logs.push({
                                                action: 'UPDATE',
                                                by: localStorage.getItem('signInEmail'),
                                                at: Date.now()
                                            });
                                            data['shash'] = shash;
                                            data['ralam'] = ralam;
                                            data['audit_logs'] = audit_logs;
                                            data['is_default'] = is_default;
                                            response1[0]['environments'][i]['services'][j]['configurations'][k] = data;
                                        }
                                    }
                                }
                            }
                        }
                    } else {
                        for (let i = 0; i < response1[0]['environments'].length; i++) {
                            if (response1[0]['environments'][i]['type'] === envType) {
                                for (let j = 0; j < response1[0]['environments'][i]['services'].length; j++) {
                                    if (response1[0]['environments'][i]['services'][j]['type'] === 'databases') {
                                        for (let k = 0; k < response1[0]['environments'][i]['services'][j]['configurations'].length; k++) {
                                            if (response1[0]['environments'][i]['services'][j]['configurations'][k]['database_name'] === data['database_name']) {
                                                response1[0]['environments'][i]['services'][j]['configurations'][k] = data;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    if (response1[0].hasOwnProperty('isEnabled')) {
                        delete response1[0].isEnabled;
                    }
                    this.confPost.patchEntityData('services', 'services', 'v2', 'settings', response1[0]['id'], response1[0]).subscribe(response2 => {
                        this.DBConnectionsUpdateStatus.push('success');
                        if (this.DBConnectionsUpdateStatus.length === environments.length) {
                            this.platform.openSnackBar('Database connection updated successfully', 'Success', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                            resolve('success');
                        }
                    }, error => {
                        this.platform.handleErrorGracefully(error, 'Error while updating data');
                        reject(error);
                        this.loadingStatus.emit('false');
                    });
                } else {
                    this.platform.openSnackBar('Error in fetching data. Please try again after sometime', 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    reject({error: 'Error in fetching settings data. Please try again after sometime'});
                    this.loadingStatus.emit('false');
                }
            }, error => {
                reject(error);
                this.platform.handleErrorGracefully(error, 'Error while fetching data');
            });
        });
    }

    updateDatabase(partner, account, data, shash, ralam) {

        Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'databaseconnection_edit_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response => {
            const payloadToSend = {
                actions: response
            };
            this.databasesListenerInstance.databasesListener.emit({
                type: 'audit',
                id: localStorage.getItem('IdOfSession'),
                payload: payloadToSend
            });
        });

        // const updateDatabasePayload = {
        //     shash: shash,
        //     ralam: ralam,
        //     databaseDetails: data
        // };
        // this.confPost.updateDatabaseConnection(partner, data['database_name'], updateDatabasePayload).subscribe(status => {

            // Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'databaseconnection_updatedatabaseconnection_success', 'INFO', data.status, data.statusText, '', {partner: partner, updateDatabasePayload: updateDatabasePayload}, data, this.router.url)).then(resp => {
            //     const payloadToSend = {
            //         actions: resp
            //     };
            //     this.databasesListenerInstance.databasesListener.emit({
            //         type: 'audit',
            //         id: localStorage.getItem('IdOfSession'),
            //         payload: payloadToSend
            //     });
            // });

            // const code = localStorage.getItem('partner');
            // const acc = localStorage.getItem('account');
            const code = partner;
            const acc = account;
            const temp = code.split('-');
            let partnerShortCode = '';
            if (temp.length > 1) {
                partnerShortCode = temp[temp.length - 1];
            } else {
                partnerShortCode = code;
            }
            const temp1 = acc.split('-');
            let account_id = '';
            if (temp1.length > 1) {
                account_id = temp1[temp1.length - 1];
            } else {
                account_id = acc;
            }
            let environments = [];
            this.confPost.getSettingsV2CRUD(partner, account, false).subscribe(async response => {
                if (response && response['body'] && response['body'][0]) {
                    environments = response['body'][0]['environments'];
                    if (environments[0]['type'] === 'admin') {
                        let index = 0;
                        for (const env of environments) {
                            index += 1;
                            let partnerName = '';
                            let accountId = '';
                            if (env['type'] !== 'prod') {
                                partnerName = env['type'] + '-' + partnerShortCode;
                                accountId = env['type'] + '-' + account_id;
                            } else {
                                partnerName = partnerShortCode;
                                accountId = account_id;
                            }

                            this.patchAdminPartnerSettingsForUpdate(partnerName, accountId, data, env['type'], environments, true, shash, ralam).then(res => {
                                Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'databaseconnection_edit_success', 'INFO', data.status, data.statusText, '', {partner: partner, databasePayload: data}, data, this.router.url)).then(resp => {
                                    const payloadToSend = {
                                        actions: resp
                                    };
                                    this.databasesListenerInstance.databasesListener.emit({
                                        type: 'audit',
                                        id: localStorage.getItem('IdOfSession'),
                                        payload: payloadToSend
                                    });
                                });
                                setTimeout(() => {
                                    window.location.reload();
                                }, 1000);
                            }, error => {
                                Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'databaseconnection_edit_failed', 'ERROR', error.status, error.statusText, this.platform.returnErrorMessage(error), {partner: partnerName, databasePayload: data}, error, this.router.url)).then(resp => {
                                    const payloadToSend = {
                                        actions: resp
                                    };
                                    this.databasesListenerInstance.databasesListener.emit({
                                        type: 'audit',
                                        id: localStorage.getItem('IdOfSession'),
                                        payload: payloadToSend
                                    });
                                });
                            });
                        }
                    } else {
                        for (let i = 0; i < response['body'][0]['environments'][0]['services'].length; i++) {
                            if (response['body'][0]['environments'][0]['services'][i]['type'] === 'databases') {
                                for (let j = 0; j < response['body'][0]['environments'][0]['services'][i]['configurations'].length; j++) {
                                    if (response['body'][0]['environments'][0]['services'][i]['configurations'][j]['database_name'] === data['database_name']) {
                                        let audit_logs = [];
                                        audit_logs = response['body'][0]['environments'][0]['services'][i]['configurations'][j]['audit_logs'];
                                        const is_default = response['body'][0]['environments'][0]['services'][i]['configurations'][j]['is_default'];
                                        audit_logs.push({
                                            action: 'UPDATE',
                                            by: localStorage.getItem('signInEmail'),
                                            at: Date.now()
                                        });
                                        data['shash'] = shash;
                                        data['ralam'] = ralam;
                                        data['audit_logs'] = audit_logs;
                                        data['is_default'] = is_default;
                                        response['body'][0]['environments'][0]['services'][i]['configurations'][j] = data;
                                    }
                                }
                            }
                        }
                        this.confPost.patchEntityData('services', 'services', 'v2', 'settings', response['body'][0]['id'], response['body'][0]).subscribe(response2 => {
                            this.patchAdminPartnerSettingsForUpdate('admin-' + partnerShortCode, 'admin-' + account_id, data, response['body'][0]['environments'][0]['type'], environments, false, shash, ralam).then(response3 => {
                                Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'databaseconnection_edit_success', 'INFO', data.status, data.statusText, '', {partner: partner, databasePayload: data}, data, this.router.url)).then(resp => {
                                    const payloadToSend = {
                                        actions: resp
                                    };
                                    this.databasesListenerInstance.databasesListener.emit({
                                        type: 'audit',
                                        id: localStorage.getItem('IdOfSession'),
                                        payload: payloadToSend
                                    });
                                });
                                this.platform.openSnackBar('Database connection updated successfully', 'Success', {
                                    duration: 5000,
                                    verticalPosition: 'top',
                                    horizontalPosition: 'center'
                                });
                                setTimeout(() => {
                                    window.location.reload();
                                }, 1000);
                            }, async error => {
                                Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'databaseconnection_edit_failed', 'ERROR', error.status, error.statusText, this.platform.returnErrorMessage(error), {partner: partner, databasePayload: data}, error, this.router.url)).then(resp => {
                                    const payloadToSend = {
                                        actions: resp
                                    };
                                    this.databasesListenerInstance.databasesListener.emit({
                                        type: 'audit',
                                        id: localStorage.getItem('IdOfSession'),
                                        payload: payloadToSend
                                    });
                                });
                                await this.platform.notifyErrorToAdmins({error: 'Error occurred while patching the admin partner settings for the partner ' + partner + ' while updating a database connection.'}, 'databaseconnection_update_notifyerrortoadmins_success', 'databaseconnection_update_notifyerrortoadmins_failed', 'Error occurred while patching the admin partner settings for the partner ' + partner + ' while updating a database connection.', {partner: partner, account: account, data: data});
                                this.loadingStatus.emit('false');
                            });
                        }, async error => {
                            await this.platform.notifyErrorToAdmins({error: 'Error occurred while patching the partner settings for the partner ' + partner + ' while updating a database connection.'}, 'databaseconnection_update_notifyerrortoadmins_success', 'databaseconnection_update_notifyerrortoadmins_failed', 'Error occurred while patching the partner settings for the partner ' + partner + ' while updating a database connection.', {partner: partner, account: account, data: data});
                            this.loadingStatus.emit('false');
                        });
                    }
                } else {
                    await this.platform.notifyErrorToAdmins({error: 'No data has been fetched from the partner settings for the partner ' + partner + ' while updating a database connection.'}, 'databaseconnection_update_notifyerrortoadmins_success', 'databaseconnection_update_notifyerrortoadmins_failed', 'No data has been fetched from the partner settings for the partner ' + partner + ' while updating a database connection.', {partner: partner, account: account, data: data});
                    this.loadingStatus.emit('false');
                }
            }, async error => {
                await this.platform.notifyErrorToAdmins({error: 'Error occurred while fetching the partner settings for the partner ' + partner + ' while updating a database connection.'}, 'databaseconnection_update_notifyerrortoadmins_success', 'databaseconnection_update_notifyerrortoadmins_failed', 'Error occurred while fetching the partner settings for the partner ' + partner + ' while updating a database connection.', {partner: partner, account: account, data: data});
                this.loadingStatus.emit('false');
            });
        // }, async error => {
        //     Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'databaseconnection_updatedatabaseconnection_failed', 'ERROR', error.status, error.statusText, this.platform.returnErrorMessage(error), {partner: partner, updateDatabasePayload: updateDatabasePayload}, error, this.router.url)).then(resp => {
        //         const payloadToSend = {
        //             actions: resp
        //         };
        //         this.databasesListenerInstance.databasesListener.emit({
        //             type: 'audit',
        //             id: localStorage.getItem('IdOfSession'),
        //             payload: payloadToSend
        //         });
        //     });
        //     this.platform.handleErrorGracefully(error, 'Error occurred while updating the DB Connection. Please try again after sometime.');
        //     await this.platform.notifyErrorToAdmins({error: 'Error occurred while updating a DB Connection for the partner ' + partner + '.'}, 'databaseconnection_update_notifyerrortoadmins_success', 'databaseconnection_update_notifyerrortoadmins_failed', 'Error occurred while updating a DB Connection for the partner ' + partner + '.', {partner: partner, account: account, data: data});
        //     this.loadingStatus.emit('false');
        // });
    }

    async getDatabaseData(databaseData, index, partner, account) {
        const data = databaseData[index];
        this.loadingStatus.emit('true');
        this.DBConnectionsUpdateStatus = [];
        const iterationCount = 1000;
        let keySize = 128;
        keySize = keySize / 32;
        const passphrase = environment.cipheringPhrase;

        const iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
        const salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
        data['shash'] = salt;
        data['ralam'] = iv;
        const attributes = Object.keys(data['database_attributes']);
        if (attributes && attributes.length > 0) {
            if (data['database_type'] === 'csv') {
                const fileAttributes = Object.keys(data['database_attributes']['files'][0]);
                for (let i = 0; i < fileAttributes.length; i++) {
                    data['database_attributes']['files'][0][fileAttributes[i]] = data['database_attributes'][fileAttributes[i]];
                    await this.platform.encryptAttribute(salt, iv, passphrase, data['database_attributes']['files'][0][fileAttributes[i]], keySize, iterationCount).then(response => {
                        data['database_attributes']['files'][0][fileAttributes[i]] = response;
                        //data['database_attributes'][fileAttributes[i]]=response;
                    });
                }
                await this.platform.encryptAttribute(salt, iv, passphrase, data['database_attributes']['connectionType'], keySize, iterationCount).then(response => {
                    data['database_attributes']['connectionType'] = response;
                });
                if (data['database_attributes']['separator'] && data['database_attributes']['separator'] !== '') {
                    await this.platform.encryptAttribute(salt, iv, passphrase, data['database_attributes']['separator'], keySize, iterationCount).then(response => {
                        data['database_attributes']['separator'] = response;
                    });
                } else {
                    delete data['database_attributes']['separator'];
                }


                if (data['database_attributes'].hasOwnProperty('url')) {
                    delete data['database_attributes']['url'];
                }
                if (data['database_attributes'].hasOwnProperty('name')) {
                    delete data['database_attributes']['name'];
                }

            } else {
                for (let i = 0; i < attributes.length; i++) {
                    await this.platform.encryptAttribute(salt, iv, passphrase, data['database_attributes'][attributes[i]], keySize, iterationCount).then(response => {
                        data['database_attributes'][attributes[i]] = response;
                    });
                }
            }
        }

        this.updateDatabase(partner, account, data, salt, iv);
        $('#databaseView').find('tbody tr').find('td').each(function () {
            if ($(this).find('input').length) {
                $(this).find('input').prop('readonly', true);
            }
            $(this).find('button').css('display', 'none');

        });
    }

    updateAdfsConfig(data) {
        this.confPost.updateAdfsConfiguration(data, localStorage.getItem('partner')).subscribe(status => {
            this.platform.openSnackBar('ADFS Configuration updated successfully', 'Success', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }, error => {
            this.platform.openSnackBar('Error while ADFS Configuration route' + (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? ': ' + error.error.message : '', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }

    sendPartnerData() {
        /* const partnerData = {
             partner: this.partner,
             partner_organization: this.partnerOrganization,
             partner_organization_type: this.partnerOrganizationType,
             primary_email: this.primaryEmail,
             primary_phone: this.primaryPhone,
             account_password: this.accountpassword,
             secondary_email: this.secondaryemail,
             secondary_phone: this.secondaryphone,
             address_line_1: this.addressLine1,
             address_line_2: this.addressLine2,
             city: this.city,
             state: this.state,
             country: this.country,
             pincode: this.pincode,
             localization: this.localization
         };*/
        // this.item['id'] = 'devopsbees';
        this.item['accounts'] = [
            {
                account_id: this.item['partner'],
                account_desc: 'default',
                account_email: this.item['primary_email'],
                account_password: this.item['account_password'],
                account_roles: [],
                entities: [],
                operations: []
            }
        ];

        this.confPost.updatePartner(this.item).subscribe(data => {
            this.platform.openSnackBar('Updated successfully', 'Success', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
            //  this.router.navigate(['/login']);
        }, error => {
            this.platform.openSnackBar('Error while data onboard. Please try after sometime', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }

    removeAccount(event, subAccount) {
        if (confirm('This action is irreversible, Are you sure you want to delete this record?')) {
            this.confPost.deleteAccount(localStorage.getItem('partner'), $(event.target).closest('td').next('td').text().trim()).subscribe(deleteData => {
                $(event.target).closest('td').parent('tr').remove();
                this.platform.openSnackBar('Account deleted successfully', 'Success', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                const deleteSubAccountPayloadForAWS = {
                    'partner': subAccount + '.' + localStorage.getItem('partner'),
                    'type': 'dnsDelete'
                };
                this.confPost.createRoute53S3Bucket(deleteSubAccountPayloadForAWS).subscribe(response => {

                });
                //  this.router.navigate(['/login']);
            }, error => {
                this.platform.handleErrorGracefully(error, 'Error while removing your account. Please try again after sometime');
            });
        } else {
        }
    }

    patchAdminPartnerForDelete(partnerName, accountId, val, envType, environments, isFromAdmin) {
        return new Promise((resolve, reject) => {
            this.confPost.getSettingsV2CRUD(partnerName, accountId, false).subscribe(res => {
                if (res && res['body'] && res['body'][0]) {
                    const response1 = res['body'];
                    if (isFromAdmin === true) {
                        for (let i = 0; i < response1[0]['environments'].length; i++) {
                            for (let j = 0; j < response1[0]['environments'][i]['services'].length; j++) {
                                if (response1[0]['environments'][i]['services'][j]['type'] === 'databases') {
                                    for (let k = 0; k < response1[0]['environments'][i]['services'][j]['configurations'].length; k++) {
                                        if (response1[0]['environments'][i]['services'][j]['configurations'][k]['database_name'] === val['database_name']) {
                                            response1[0]['environments'][i]['services'][j]['configurations'].splice(k, 1);
                                        }
                                    }
                                }
                            }
                        }
                    } else {
                        for (let i = 0; i < response1[0]['environments'].length; i++) {
                            if (response1[0]['environments'][i]['type'] === envType) {
                                for (let j = 0; j < response1[0]['environments'][i]['services'].length; j++) {
                                    if (response1[0]['environments'][i]['services'][j]['type'] === 'databases') {
                                        for (let k = 0; k < response1[0]['environments'][i]['services'][j]['configurations'].length; k++) {
                                            if (response1[0]['environments'][i]['services'][j]['configurations'][k]['database_name'] === val['database_name']) {
                                                response1[0]['environments'][i]['services'][j]['configurations'].splice(k, 1);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    this.confPost.patchEntityData('services', 'services', 'v2', 'settings', response1[0]['id'], response1[0]).subscribe(response2 => {
                        this.removeDBConnectionsStatus.push('success');
                        if (this.removeDBConnectionsStatus.length === environments.length) {
                            this.platform.openSnackBar('Connection deleted successfully', 'Success', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        }
                        resolve('success');
                    }, error => {
                        reject(error);
                    });
                } else {
                    reject({error: 'Error in fetching settings data. Please try again after sometime'});
                    this.platform.openSnackBar('Error in retrieving data. Please try again after sometime', 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    this.loadingStatus.emit('false');
                }
            });
        });
    }

    removeDBConnection(partner, account, val, data1, index) {
        return new Promise((resolve, reject) => {
            // this.confPost.deleteDatabase(partner, val['database_name']).subscribe(data => {

                // Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'databaseconnection_removedatabaseconnection_success', 'INFO', data.status, data.statusText, '', {partner: partner, databasePayload: val}, data, this.router.url)).then(resp => {
                //     const payloadToSend = {
                //         actions: resp
                //     };
                //     this.databasesListenerInstance.databasesListener.emit({
                //         type: 'audit',
                //         id: localStorage.getItem('IdOfSession'),
                //         payload: payloadToSend
                //     });
                // });

                data1.splice(index, 1);
                // const code = localStorage.getItem('partner');
                // const acc = localStorage.getItem('account');
                const code = partner;
                const acc = account;
                const temp = code.split('-');
                let partnerShortCode = '';
                if (temp.length > 1) {
                    partnerShortCode = temp[temp.length - 1];
                } else {
                    partnerShortCode = code;
                }
                const temp1 = acc.split('-');
                let account_id = '';
                if (temp1.length > 1) {
                    account_id = temp1[temp1.length - 1];
                } else {
                    account_id = acc;
                }
                let environments = [];
                this.confPost.getSettingsV2CRUD(partner, account, false).subscribe(response => {
                    if (response && response['body'] && response['body'][0]) {
                        environments = response['body'][0]['environments'];
                        if (response['body'][0]['environments'][0]['type'] === 'admin') {
                            let index1 = 0;
                            for (const env of environments) {
                                index1 += 1;
                                let partnerName = '';
                                let accountId = '';
                                if (env['type'] !== 'prod') {
                                    partnerName = env['type'] + '-' + partnerShortCode;
                                    accountId = env['type'] + '-' + account_id;
                                } else {
                                    partnerName = partnerShortCode;
                                    accountId = account_id;
                                }
                                this.patchAdminPartnerForDelete(partnerName, accountId, val, env['type'], environments, true).then(res => {
                                    Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'databaseconnection_delete_success', 'INFO', 200, 'OK', '', {partner: partner, databasePayload: val}, res, this.router.url)).then(resp => {
                                        const payloadToSend = {
                                            actions: resp
                                        };
                                        this.databasesListenerInstance.databasesListener.emit({
                                            type: 'audit',
                                            id: localStorage.getItem('IdOfSession'),
                                            payload: payloadToSend
                                        });
                                    });
                                    setTimeout(() => {
                                        window.location.reload();
                                    }, 1000);
                                }, error => {
                                    Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'databaseconnection_delete_failed', 'ERROR', error.status, error.statusText, this.platform.returnErrorMessage(error), {partner: partner, databasePayload: val}, error, this.router.url)).then(resp => {
                                        const payloadToSend = {
                                            actions: resp
                                        };
                                        this.databasesListenerInstance.databasesListener.emit({
                                            type: 'audit',
                                            id: localStorage.getItem('IdOfSession'),
                                            payload: payloadToSend
                                        });
                                    });
                                });
                            }
                        } else {
                            const response1 = response['body'];
                            for (let i = 0; i < response1[0]['environments'].length; i++) {
                                for (let j = 0; j < response1[0]['environments'][i]['services'].length; j++) {
                                    if (response1[0]['environments'][i]['services'][j]['type'] === 'databases') {
                                        for (let k = 0; k < response1[0]['environments'][i]['services'][j]['configurations'].length; k++) {
                                            if (response1[0]['environments'][i]['services'][j]['configurations'][k]['database_name'] === val['database_name']) {
                                                response1[0]['environments'][i]['services'][j]['configurations'].splice(k, 1);
                                            }
                                        }
                                    }
                                }
                            }
                            this.confPost.patchEntityData('services', 'services', 'v2', 'settings', response1[0]['id'], response1[0]).subscribe(response2 => {
                                this.patchAdminPartnerForDelete('admin-' + partnerShortCode, 'admin-' + account_id, val, response1[0]['environments'][0]['type'], environments, false).then(response3 => {
                                    Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'databaseconnection_delete_success', 'INFO', 200, 'OK', '', {partner: partner, databasePayload: val}, response3, this.router.url)).then(resp => {
                                        const payloadToSend = {
                                            actions: resp
                                        };
                                        this.databasesListenerInstance.databasesListener.emit({
                                            type: 'audit',
                                            id: localStorage.getItem('IdOfSession'),
                                            payload: payloadToSend
                                        });
                                    });
                                    this.platform.openSnackBar('Connection deleted successfully', 'Success', {
                                        duration: 5000,
                                        verticalPosition: 'top',
                                        horizontalPosition: 'center'
                                    });
                                    setTimeout(() => {
                                        window.location.reload();
                                    }, 1000);
                                    resolve('success');
                                }, async error => {
                                    Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'databaseconnection_delete_failed', 'ERROR', error.status, error.statusText, this.platform.returnErrorMessage(error), {partner: partner, databasePayload: val}, error, this.router.url)).then(resp => {
                                        const payloadToSend = {
                                            actions: resp
                                        };
                                        this.databasesListenerInstance.databasesListener.emit({
                                            type: 'audit',
                                            id: localStorage.getItem('IdOfSession'),
                                            payload: payloadToSend
                                        });
                                    });
                                    await this.platform.notifyErrorToAdmins({error: 'Error occurred while patching the admin partner settings for the partner ' + partner + ' while deleting a database connection.'}, 'databaseconnection_delete_notifyerrortoadmins_success', 'databaseconnection_delete_notifyerrortoadmins_failed', 'Error occurred while patching the admin partner settings for the partner ' + partner + ' while deleting a database connection.', {partner: partner, account: account, data: val});
                                });
                            }, async error => {
                                await this.platform.notifyErrorToAdmins({error: 'Error occurred while patching the partner settings for the partner ' + partner + ' while deleting a database connection.'}, 'databaseconnection_delete_notifyerrortoadmins_success', 'databaseconnection_delete_notifyerrortoadmins_failed', 'Error occurred while patching the partner settings for the partner ' + partner + ' while deleting a database connection.', {partner: partner, account: account, data: val});
                            });
                        }
                    } else {
                        this.platform.notifyErrorToAdmins({error: 'No data has been fetched from the partner settings for the partner ' + partner + ' while deleting a database connection.'}, 'databaseconnection_delete_notifyerrortoadmins_success', 'databaseconnection_delete_notifyerrortoadmins_failed', 'No data has been fetched from the partner settings for the partner ' + partner + ' while deleting a database connection.', {partner: partner, account: account, data: val});
                        this.platform.openSnackBar('Error in retrieving data. Please try again after sometime', 'Error', {
                            duration: 5000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                        this.loadingStatus.emit('false');
                    }

                }, error => {
                    this.platform.handleErrorGracefully(error, 'Error occurred while deleting the DB Connection. Please try again after sometime');
                    this.platform.notifyErrorToAdmins({error: 'Error while fetching the data from the partner settings for the partner ' + partner + ' while deleting a database connection.'}, 'databaseconnection_delete_notifyerrortoadmins_success', 'databaseconnection_delete_notifyerrortoadmins_failed', 'Error while fetching the data from the partner settings for the partner ' + partner + ' while deleting a database connection.', {partner: partner, account: account, data: val});
                    this.loadingStatus.emit('false');
                });
            // }, async error => {
            //     Promise.resolve(this.platform.generateActionPayloadForAudit(true, 'databaseconnection_removedatabaseconnection_failed', 'ERROR', error.status, error.statusText, this.platform.returnErrorMessage(error), {partner: partner, databasePayload: val}, error, this.router.url)).then(resp => {
            //         const payloadToSend = {
            //             actions: resp
            //         };
            //         this.databasesListenerInstance.databasesListener.emit({
            //             type: 'audit',
            //             id: localStorage.getItem('IdOfSession'),
            //             payload: payloadToSend
            //         });
            //     });
            //     this.platform.handleErrorGracefully(error, 'Error occurred while deleting the DB Connection. Please try again after sometime.');
            //     await this.platform.notifyErrorToAdmins({error: 'Error while deleting a DB Connection for the partner ' + partner + '.'}, 'databaseconnection_delete_notifyerrortoadmins_success', 'databaseconnection_delete_notifyerrortoadmins_failed', 'Error while deleting a DB Connection for the partner ' + partner + '.', {partner: partner, account: account, data: val});
            //     this.loadingStatus.emit('false');
            // });
        });
    }

    removeDatabase(data1, index, event, partner, account) {
        // const db = val[0]['database_name'];
        Promise.resolve(this.platform.generateActionPayloadForAudit(false, 'databaseconnection_delete_clicked', 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response => {
            const payloadToSend = {
                actions: response
            };
            this.databasesListenerInstance.databasesListener.emit({
                type: 'audit',
                id: localStorage.getItem('IdOfSession'),
                payload: payloadToSend
            });
        });
        const val = data1[index];
        if (val['database_name'] !== '') {
            if (confirm('This action is irreversible, Are you sure you want to delete this record?')) {
                this.loadingStatus.emit('true');
                this.removeDBConnectionsStatus = [];
                this.removeDBConnection(partner, account, val, data1, index);
            }
        } else {
            alert('Database name cannot be empty');
        }
    }

    // removeDatabase(event) {
    //     if (confirm('This action is irreversible, Are you sure you want to delete this record?')) {
    //         this.confPost.deleteDatabase(localStorage.getItem('partner'), $(event.target).closest('td').next('td').text().trim()).subscribe(deleteData => {
    //             $(event.target).closest('td').parent('tr').remove();
    //             this.platform.openSnackBar('Database deleted successfully', 'Success', {
    //                 duration: 5000,
    //                 verticalPosition: 'top',
    //                 horizontalPosition: 'center'
    //             });
    //             //  this.router.navigate(['/login']);
    //         }, error => {
    //             this.platform.openSnackBar('Error. Please try after sometime', 'Error', {
    //                 duration: 5000,
    //                 verticalPosition: 'top',
    //                 horizontalPosition: 'center'
    //             });
    //         });
    //     } else {
    //     }
    // }

    editDatabase(event, index) {
        $(event.target).closest('td').parent('tr').find('td').each(function () {
            if ($(this).find('input').length) {
                if (index !== 1) {
                    $(this).find('input').prop('readonly', false);
                }
            }
            $(this).find('button').css('display', 'block');
            index += 1;
        });
    }
}

@Component({
    selector: 'dialog-overview-example-dialog',
    templateUrl: 'account-add.component.html',
})
export class DialogOverviewExampleDialogComponent {

    constructor(
        private confPost: ConfService, public platform: LeftpanelComponent,
        public dialogRef: MatDialogRef<DialogOverviewExampleDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    }

    // createAccount = {account: '', account_desc: '', account_email: '', account_password: ''};
    createAccount = {account_id: '', account_desc: '', account_email: '', account_password: ''};


    onNoClick(): void {
        this.dialogRef.close();
    }

    createAccountFn(result) {
        if (result['account'] !== '' && result['account_desc'] !== '' && result['account_email'] !== '' && result['account_password'] !== '') {
            this.confPost.insertAccount(localStorage.getItem('partner'), result).subscribe(data => {
                this.platform.openSnackBar('Account created successfully', 'Success', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                const createSubAccountPayloadForAWS = {
                    'partner': result['account'] + '.' + localStorage.getItem('partner'),
                    'type': 'dnsInsert'
                };
                this.confPost.createRoute53S3Bucket(createSubAccountPayloadForAWS).subscribe(response => {

                });
            });
        } else {
            this.platform.openSnackBar('Error in creating account. Some fields are missing.', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }
}

@Component({
    selector: 'create-database-dialog',
    templateUrl: 'database-add.component.html',
    styleUrls: ['database-add.component.css']
})

export class CreateDatabaseComponent implements OnInit {

    @ViewChild('myForm', {static: false}) public MyForm: NgForm;
    @ViewChild('myForm1', {static: false}) public MyForm1: NgModel;
    @ViewChild('myForm2', {static: false}) public MyForm2: NgModel;

    constructor(
        private confPost: ConfService, public platform: LeftpanelComponent,
        public dialogRef: MatDialogRef<CreateDatabaseComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DatabaseData) {
    }

    item = {};
    showConnectionStringForMongo: boolean;
    back: boolean;
    keys = [];
    connectionTypes = [];

    ngOnInit() {
        this.item['database_attributes'] = {};
        // this.item['standardConnection'] = false;
        // this.item['srvConnection'] = false;
        this.showConnectionStringForMongo = false;
        this.back = false;
        this.connectionTypes = ['DNS Seedlist Connection', 'Standard Connection'];
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    showConnectionString() {
        this.showConnectionStringForMongo = true;
        this.back = true;
    }

    goBackToConnectionType() {
        this.showConnectionStringForMongo = false;
        this.back = false;
    }

    testDbConnection(val, db) {
        val['database_type'] = db;

        if (val['database_type'] === 'mongodb' || val['database_type'] === 'mysql' || val['database_type'] === 'aurora-mysql' || val['database_type'] === 'sqlserver' || val['database_type'] === 'postgresql' || val['database_type'] === 'aurora-postgresql' || val['database_type'] === 'snowflake') {
            if (val['database_type'] === 'mongodb') {
                if (!this.back) {
                    if (this.MyForm1.valid && this.MyForm2.valid) {
                        if (this.MyForm.valid) {
                            val['database_attributes']['connectionString'] = '';
                            this.testConnection(db, val);
                        } else {
                            alert('Please choose one of the connection types');
                        }
                    } else {
                        alert('Please provide database_name and host');
                    }
                } else {
                    if (this.MyForm2.valid) {
                        if (val['database_attributes']['connectionString'] === '' || val['database_attributes']['connectionString'] == null) {
                            alert('Please provide a valid connection string');
                        } else {
                            this.testConnection(db, val);
                        }
                    } else {
                        alert('Please provide database_name');
                    }
                }
            } else {
                if (this.MyForm1.valid && this.MyForm2.valid) {
                    this.testConnection(db, val);
                } else {
                    alert('Please provide database_name and host');
                }
            }
        } else if (val['database_type'] === 'cosmosdb') {
            if (this.MyForm2.valid) {
                this.testConnection(db, val);
            } else {
                alert('Please provide database_name');
            }
        } else {
            this.testConnection(db, val);
        }
    }

    testConnection(db, val) {
        this.confPost.testConnectionDatabase(val).subscribe(data => {
            this.platform.openSnackBar(data.body['message'], '', {
                duration: 5000,
                panelClass: ['successColor'],
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
            // this.dialogRef.close(true);
        }, error => {
            alert('STATUS CODE: ' + error.status + '\nMESSAGE: ' + this.platform.returnErrorMessage(error));
            // this.platform.openSnackBar(error.error.message, 'Error', {
            //     duration: 5000,
            //     verticalPosition: 'top',
            //     horizontalPosition: 'center'
            // });
        });
    }

    createDatabase(val, db) {

        val['database_type'] = db;

        if (val['database_type'] === 'mongodb' || val['database_type'] === 'mysql' || val['database_type'] === 'aurora-mysql' || val['database_type'] === 'sqlserver' || val['database_type'] === 'postgresql' || val['database_type'] === 'aurora-postgresql' || val['database_type'] === 'snowflake') {
            if (val['database_type'] === 'mongodb') {
                if (!this.back) {
                    if (this.MyForm1.valid && this.MyForm2.valid) {
                        if (this.MyForm.valid) {
                            val['database_attributes']['connectionString'] = '';
                            this.createConnection(db, val);
                        } else {
                            alert('Please choose one of the connection types');
                        }
                    } else {
                        alert('Please make sure you have provided both database_name and host');
                    }
                } else {
                    if (this.MyForm2.valid) {
                        if (val['database_attributes']['connectionString'] === '' || val['database_attributes']['connectionString'] == null) {
                            alert('Please provide a valid connection string');
                        } else {
                            this.createConnection(db, val);
                        }
                    } else {
                        alert('Please provide a database_name');
                    }
                }
            } else {
                if (this.MyForm1.valid && this.MyForm2.valid) {
                    this.createConnection(db, val);
                } else {
                    alert('Please make sure you have provided both database_name and host');
                }
            }
        } else if (val['database_type'] === 'cosmosdb') {
            if (this.MyForm2.valid) {
                this.createConnection(db, val);
            } else {
                alert('Please provide a database_name');
            }
        } else {
            val['region'] = val['database_attributes']['region'];
            this.createConnection(db, val);
        }
    }

    createConnection(db, result) {
        this.confPost.insertDatabase(localStorage.getItem('partner'), result).subscribe(data => {
            this.platform.openSnackBar('Database created successfully', 'Success', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
            this.dialogRef.close(true);
        }, error => {
            this.platform.handleErrorGracefully(error, 'Error while creating database');
        });
    }
}
